module.exports = "https://beta.voredev.ru/assets/index/quiz-blue-line-fda42fc942a7d1d8de1167338f34d2e2.svg";